export const aiAssistant = {
  save: "Save",
  mockWarning: {
    title: "🤖 Working with mock data",
    description: "This feature requires real AI generation, which comes with token costs. Currently, we're using mock (preset) data for testing purposes only."
  },
  chat: {
    title: "Let's chat! 💬",
    subtitle: "I'm here to help you build your dream website",
    welcomeMessage: "Hey there! 👋 So excited to have you here! I'm going to help you create the perfect website. Tell me a bit about yourself and what you're looking for!",
    loadingMessages: [
      "Hmm, interesting... 🤔",
      "Oh, that's a great idea! ✨", 
      "I can already see how this will look! 🎨",
      "You're going to love this! 😍",
      "Awesome choice! 🚀"
    ],
    placeholders: {
      default: "Write anything... I'll understand! 😊",
      waiting: "So, tell me! What do you think? 🤗",
      multiselect: "Choose freely, or write something else!",
      continue: "Great! What shall we do next? ✨"
    }
  },
  quickActions: {
    paid: "Paid content",
    interactive: "Interactive feature",
    content: "Content",
    paidTitle: "Paid content",
    interactiveTitle: "Interactive features", 
    contentTitle: "Content upload",
    actions: {
      // Paid content
      digitalProduct: "New digital product upload",
      privateMeeting: "New private meeting",
      groupMeeting: "New group meeting", 
      questionForm: "New question form",
      personalVideo: "New personal video order",
      package: "New package",
      
      // Interactive features
      lottery: "New lottery",
      quiz: "New quiz",
      poll: "New poll",
      subscription: "New subscription", 
      promoCode: "New promo code",
      link: "New link setup",
      
      // Content
      contentUpload: "New content",
      embeddedVideo: "New embedded video",
      faq: "New FAQ", 
      reviews: "New reviews",
      howItWorks: "New how it works?"
    }
  },
  productIdeas: {
    title: "AI Product Idea Generator",
    subtitle: "Generate product ideas and build them with AI Builder",
    selectType: "Product type",
    generateButton: "Generate ideas",
    generating: "Generating...",
    generatedIdeas: "Generated product ideas",
    customize: "Customize",
    customizeTitle: "Customize product idea",
    customizeDescription: "Customize the idea, then send it to AI Website Builder",
    sendToBuilder: "Send to Builder",
    productTitle: "Product title",
    productDescription: "Description",
    price: "Price (HUF)",
    features: "Features (one per line)",
    targetAudience: "Target audience",
    cancel: "Cancel",
    ideaGenerated: "Product ideas generated!",
    ideaSentToBuilder: "Idea sent!",
    ideaSentDescription: "The product idea has been sent to AI Website Builder."
  }
};